var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4363 0.106247C19.0635 -0.0716027 18.6242 -0.0244618 18.3028 0.234813L7.88037 8.57232H2.90058C1.71992 8.57232 0.757812 9.53443 0.757812 10.7151V19.2862C0.757812 20.4668 1.71992 21.4289 2.90058 21.4289H7.88037L18.3007 29.7664C18.4956 29.9207 18.7335 30 18.9713 30C19.1299 30 19.2885 29.9657 19.4363 29.895C19.807 29.715 20.0427 29.34 20.0427 28.9286V1.07264C20.0427 0.661224 19.807 0.28624 19.4363 0.106247ZM7.18612 19.2862H2.90058V10.7151H7.18612V19.2862ZM17.9 26.698L9.32888 19.8411V10.1601L17.9 3.30326V26.698Z",
    fill: "url(#paint0_linear_2993_7143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4702 7.42418C25.0481 7.00634 24.3709 7.01277 23.9553 7.43275C23.5396 7.85488 23.5438 8.53199 23.9638 8.94769C25.5816 10.5483 26.473 12.6975 26.473 15.001C26.473 17.3045 25.5816 19.4537 23.9638 21.0543C23.5417 21.47 23.5374 22.1471 23.9553 22.5693C24.1652 22.7814 24.4417 22.8864 24.7159 22.8864C24.9881 22.8864 25.2602 22.7835 25.4702 22.5757C27.4994 20.5722 28.6158 17.883 28.6158 15.001C28.6158 12.119 27.4994 9.42981 25.4702 7.42418Z",
    fill: "url(#paint1_linear_2993_7143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4902 4.40588C28.0702 3.99018 27.3909 3.99232 26.9752 4.41231C26.5595 4.83229 26.5617 5.51155 26.9816 5.92724C29.4158 8.34214 30.7572 11.5649 30.7572 15.0019C30.7572 18.4389 29.4158 21.6616 26.9816 24.0765C26.5617 24.4922 26.5595 25.1714 26.9752 25.5914C27.1852 25.8036 27.4595 25.9086 27.7359 25.9086C28.008 25.9086 28.2802 25.8057 28.4902 25.5979C31.3336 22.778 32.9 19.0153 32.9 15.0019C32.9 10.9885 31.3336 7.22576 28.4902 4.40588Z",
    fill: "url(#paint2_linear_2993_7143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2993_7143",
    x1: 0.757813,
    y1: 30,
    x2: 28.0498,
    y2: 12.4559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2993_7143",
    x1: 23.6445,
    y1: 22.8864,
    x2: 32.6885,
    y2: 20.0358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2993_7143",
    x1: 26.665,
    y1: 25.9086,
    x2: 38.193,
    y2: 22.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/VolumeIcon.11d03f305bbcabf997c83698ef68221e.svg";
export { ForwardRef as ReactComponent };